import { render, staticRenderFns } from "./tabColors.vue?vue&type=template&id=4de74d94&scoped=true"
import script from "./tabColors.vue?vue&type=script&lang=js"
export * from "./tabColors.vue?vue&type=script&lang=js"
import style0 from "./tabColors.vue?vue&type=style&index=0&id=4de74d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de74d94",
  null
  
)

export default component.exports